import { createContext } from "react";

export const UserAccessContext = createContext<
  Record<string, boolean> | undefined
>(undefined);
